export default __webpack_public_path__ + "static/media/bg-feedback-0.80f278f4.png";